module.exports = {"360622100":"邓埠镇","360622101":"锦江镇","360622102":"潢溪镇","360622103":"中童镇","360622104":"马荃镇","360622105":"画桥镇","360622106":"春涛镇","360622200":"平定乡","360622202":"杨溪乡","360622203":"洪湖乡","360622204":"黄庄乡","360622205":"刘家站乡","360622408":"余江县工业园区","360622409":"鹰潭市龙岗新区","360622501":"高公寨营林场","360622503":"邓家埠水稻原种场","360622504":"余江县水产场","360622505":"塘潮源林场","360622506":"张公桥农场","360622507":"青年综合垦殖场","360622508":"大桥农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360622.json
// module id = 1184
// module chunks = 0